import { render, staticRenderFns } from "./CaiwuDanweiList.vue?vue&type=template&id=580f4e9d&"
import script from "./CaiwuDanweiList.vue?vue&type=script&lang=js&"
export * from "./CaiwuDanweiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports